import { Helmet } from 'react-helmet-async';
import HeroSection from '../components/HeroSection';
import FeaturesSection from '../components/FeaturesSection';
import HowItWorksSection from '../components/HowItWorksSection';
import CTASection from '../components/CTASection';

export default function HomePage() {
  return (
    <>
      <Helmet>
        <title>FileMingle — Smart File Tools, All in One Place</title>
        <meta
          name="description"
          content="Create fillable PDFs, convert images, compress files, and manage documents effortlessly with FileMingle — directly in your browser."
        />
        <link rel="canonical" href="https://filemingle.com/" />
      </Helmet>
      <HeroSection />
      <FeaturesSection />
      <HowItWorksSection />
      <CTASection />
    </>
  );
}
